import { useState, useEffect, FC, Dispatch, SetStateAction } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { DashboardDiagnosticIsInferredQuery } from '../../graphQLOperations/__generated__/DashboardDiagnosticIsInferredQuery.graphql';
import { getDiagnosticIsInferred } from '../../graphQLOperations/Dashboard';
import { useAppSelector } from '../../redux/hooks';
import { selectUser } from '../../redux/reducers/userSlice';

interface Props {
  setIsInferred: (value: boolean) => void;
  previousDiagnosticId: string | null;
  setShowInferredSkills: Dispatch<SetStateAction<boolean>>;
}

const IsInferredQueryComponent: FC<Props> = ({ setIsInferred, previousDiagnosticId, setShowInferredSkills }) => {
  const userRedux = useAppSelector(selectUser);
  const [refetchTrigger, setRefetchTrigger] = useState<number>(0);
  const { latestCompletedStudentSkillDiagnostic } = useLazyLoadQuery<DashboardDiagnosticIsInferredQuery>(
    getDiagnosticIsInferred,
    {
      studentId: `StudentNode:${userRedux?.id}`,
    },
    { fetchKey: refetchTrigger, fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    setShowInferredSkills(true);
    const interval = setInterval(() => {
      setRefetchTrigger(prevKey => prevKey + 1);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (
      latestCompletedStudentSkillDiagnostic?.isInferred &&
      previousDiagnosticId !== latestCompletedStudentSkillDiagnostic.id
    ) {
      setIsInferred(true);
      // Temporarily removed
      // refreshStudentSkillStates();
      localStorage.removeItem('diagnostic_finished');
    }
  }, [latestCompletedStudentSkillDiagnostic]);

  return <div style={{ display: 'none' }}></div>;
};

export default IsInferredQueryComponent;
